import { useMemo } from 'react';
import OptionsList from 'components/OptionsList';
import { OptionItem } from 'components/OptionsList/types';
import { useExportTranscriptModalContext } from './ExportTranscriptModalContext';
import MaxCharactersPerLineControl from './MaxCharactersPerLineControl';
import {
  checkIsFileTypeSupportedForIncludeTimestamps,
  checkIsFileTypeUnsupportedForSliceByCharCount,
} from './utils';

export interface AdditionalFormattingOptionsProps {}

const AdditionalFormattingOptions: React.FC<
  AdditionalFormattingOptionsProps
> = () => {
  const {
    downloadFormatting: { includeStaticTimeMarkers, sliceByCharCount },
    format,
    onDownloadFormattingChange,
  } = useExportTranscriptModalContext();

  const isTimestampsSupported =
    checkIsFileTypeSupportedForIncludeTimestamps(format);

  const labelFormattingItems = useMemo((): OptionItem[] => {
    return [
      {
        key: 'includeStaticTimeMarkers',
        value: includeStaticTimeMarkers,
        label: 'Include timestamps (adds “HH:MM:SS” every 5 minutes)',
        tooltipContents: !isTimestampsSupported
          ? 'This option is not available for the selected file type'
          : null,
        isDisabled: !isTimestampsSupported,
      },
      {
        key: 'sliceByCharCount',
        label: 'Max characters per line',
        isDisabled: checkIsFileTypeUnsupportedForSliceByCharCount(format),
        render: ({ label, isDisabled }) => (
          <MaxCharactersPerLineControl
            {...{ label, isDisabled }}
            value={sliceByCharCount}
            onChange={(value) =>
              onDownloadFormattingChange('sliceByCharCount', value)
            }
          />
        ),
      },
    ];
  }, [
    format,
    includeStaticTimeMarkers,
    isTimestampsSupported,
    sliceByCharCount,
    onDownloadFormattingChange,
  ]);

  return (
    <OptionsList
      label="Additional formatting"
      items={labelFormattingItems}
      onChange={onDownloadFormattingChange}
    />
  );
};

export default AdditionalFormattingOptions;
